/**
 *
 * 平台菜单权限及路由配置说明
 *
 * 1、systemPages 整个system用户的所有页面 需要用户登陆才能使用的所有页面
 * 2、定义在systemPages的每个对象都会生成对应路由，否则未定义，则找不到页面
 * 3、路由规则 system/company/companyList 匹配为  system 平台 category = 'company' 菜单 children 中 url 为 companyList 或子 children 中的 路由
 * 4、匹配 对应 view 为 system 目录下 category 目录下 companyList
 */

const system = {
  pages: {
    menu: [
      {
        title: '特行管理',
        url: 'company',
        icon: 'md-paper',
        children: [
          {title: '特行企业管理', url: 'companyList', right: 'menu.sys.company.companyList'},
          {
            title: '特行企业管理',
            url: 'companyManage',
            right: 'menu.sys.company.companyManage',
            menu: false,
            active_url: 'companyList'
          },
          {title: '特行企业备案', url: 'companyAuth', right: 'menu.sys.company.companyAuth'},
          {title: '从业人员管理', url: 'userList', right: 'menu.sys.company.userList'},
          {title: '从业人员管理', url: 'userManage', right: 'menu.sys.company.userManage', menu: false},
          {title: '从业人员备案', url: 'userAuth', right: 'menu.sys.company.userAuth'}
        ]
      },
      {
        title: '公众网上查询',
        url: 'public',
        icon: 'md-browsers',
        children: [
          {title: '单位备案信息', url: 'orgPages', right: 'menu.sys.public.orgPages'},
          {title: '印章备案信息', url: 'sealPages', right: 'menu.sys.public.sealPages'},
          // { title: '查看单位信息', url: 'editUnitInfo', right: 'menu.sys.company.editUnitInfo', menu: false }
          // { title: '印章管理', url: 'sealManage', right: 'menu.sys.company.sealManage' },
        ]
      },
      {
        title: '工商数据',
        url: 'businessData',
        icon: 'md-filing',
        children: [
          {title: '推送列表', url: 'pushList', right: 'menu.sys.company.pushList'},
          // { title: '推送统计', url: 'pushStat', right: 'menu.sys.company.pushStat' }
        ]
      },
      {
        title: '实物公章订单',
        url: 'order',
        icon: 'md-list-box',
        children: [
          {title: '章材审核', url: 'materialManage', right: 'menu.sys.order.materialManage'},
          {title: '当前订单', url: 'currentOrder', right: 'menu.sys.order.currentOrder'},
          {title: '历史订单', url: 'historyOrder', right: 'menu.sys.order.historyOrder'},
          {title: '未付款订单', url: 'unpaidOrder', right: 'menu.sys.order.unpaidOrder'},
          {title: '订单详情', url: 'orderInfo', right: 'menu.sys.order.orderInfo', menu: false},
          {title: '订单统计', url: 'stat', right: 'menu.sys.order.stat'},
          {title: '业务统计', url: 'businessstat', right: 'menu.sys.order.businessstat', menu: false},
        ]
      },
      {
        title: '免费刻章',
        url: 'free',
        icon: 'md-list-box',
        children: [
          {title: '当前信息', url: 'info', right: 'sys.free.info'},
          {title: '预约管理', url: 'reservation', right: 'sys.free.reservation'},
          {title: '账务统计', url: 'billing', right: 'sys.free.billing'},
          {title: '签约刻章店', url: 'makerView', right: 'sys.free.makerView'},
          {title: '买单方管理', url: 'payer', right: 'sys.free.payer'},
          {title: '网点管理', url: 'locale', right: 'sys.free.locale'},
          {title: '套餐管理', url: 'plan', right: 'sys.free.plan'},
          {title: '刻章店管理', url: 'maker', right: 'sys.free.maker'},
        ]
      },
      {
        title: '政府送章',
        url: 'state',
        icon: 'md-list-box',
        children: [
          {title: '派单查看', url: 'reservation', right: 'sys.state.reservation'},
          {title: '送章地点', url: 'locale', right: 'sys.state.locale'},
          {title: '套餐管理', url: 'plan', right: 'sys.state.plan'},
        ]
      },
      {
        title: '电子公章订单',
        url: 'eSeal',
        icon: 'md-list-box',
        children: [
          {title: '电子公章受理', url: 'eSealAccept'},
          {title: '电子公章制作', url: 'eSealMake'},
          {title: '历史电子公章', url: 'eSealHistory'},
          {title: '章模处理工具', url: 'eSealUtil', right: 'menu.sys.eSeal.eSealUtil'},
          {title: '录入电子公章', url: 'eSealEdit', menu: false},
          {title: '电子公章详情', url: 'eSealInfo', menu: false}
        ]
      },
      {
        title: '备案管理',
        url: 'sealBiz',
        icon: 'md-document',
        children: [
          {
            title: '备案申报',
            url: 'registerManage/registerDeclaration',
            right: 'menu.sys.registerManage.registerDeclaration'
          },
          {title: '备案审核', url: 'registerManage/registerCheck', right: 'menu.sys.registerManage.registerCheck'},
          {title: '已备案列表', url: 'registerManage/registeredList', right: 'menu.sys.registerManage.registeredList'},
          {title: '备案接收', url: 'registerManage/registerReview', right: 'menu.sys.registerManage.registerReview'},
          {title: '全部备案单', url: 'registerManage/reviewedList', right: 'menu.sys.registerManage.reviewedList'},
          {title: '新增申报', url: 'registerManage/newRegister', right: 'menu.sys.registerManage.newRegister', menu: false},
          {
            title: '备案详情',
            url: 'registerManage/registerInfo',
            right: 'menu.sys.registerManage.registerInfo',
            menu: false
          },
          {
            title: '修改备案',
            url: 'registerManage/alterRegister',
            right: 'menu.sys.registerManage.alterRegister',
            menu: false
          }
        ]
      },
      {
        title: '作废管理',
        url: 'sealBiz',
        icon: 'md-repeat',
        children: [
          {title: '作废申报', url: 'cancelManage/cancelDeclaration', right: 'menu.sys.cancelManage.cancelDeclaration'},
          {title: '作废审核', url: 'cancelManage/cancelCheck', right: 'menu.sys.cancelManage.cancelCheck'},
          {title: '历史作废单', url: 'cancelManage/canceledList', right: 'menu.sys.cancelManage.canceledList'},
          {
            title: '新增作废申报',
            url: 'cancelManage/newDiscardRegister',
            right: 'menu.sys.cancelManage.newDiscardRegiste',
            menu: false
          },
          {
            title: '备案详情',
            url: 'cancelManage/discardRegisterInfo',
            right: 'menu.sys.cancelManage.discardRegisterInfo',
            menu: false
          },
        ]
      },
      {
        title: '信息查询',
        url: 'sealBiz',
        icon: 'md-search',
        children: [
          {title: '印章查询（全系统）', url: 'infoQuery/allSealStat', right: 'menu.sys.infoQuery.allSealStat'},
          {title: '印章查询（辖区）', url: 'infoQuery/lowerSealStat', right: 'menu.sys.infoQuery.lowerSealStat'},
          {title: '备案单查询（全系统）', url: 'registerManage/pagesReviewed', right: 'menu.sys.registerManage.pagesReviewed'},
          {title: '印章重传印迹', url: 'infoQuery/sealQueryToScan', right: 'menu.sys.infoQuery.sealQueryToScan'},
          {title: '使用单位查询', url: 'infoQuery/unitsStat', right: 'menu.sys.infoQuery.unitsStat'},
        ]
      },
      {
        title: '业务统计',
        url: 'sealBiz',
        icon: 'md-podium',
        children: [
          {title: '区县业务统计', url: 'businessStat/supervisorStat', right: 'menu.sys.businessStat.supervisorStat'},
          {title: '刻章店业务统计', url: 'businessStat/sealContentStat', right: 'menu.sys.businessStat.sealContentStat'},
          // { title: '当前业务概况', url: 'businessStat/currentBusinessInfo', right: 'menu.sys.businessStat.currentBusinessInfo' },
          // { title: 'echart', url: 'businessStat/echartTest', right: 'menu.sys.businessStat.echartTest'  },
        ]
      },
      {
        title: '新闻动态',
        icon: 'md-trending-up',
        url: 'info',
        children: [
          {title: '文章专题', url: 'articleList', query: {type: 'LAWS'}, right: 'menu.sys.info.articleList'},
          {title: '联系我们', url: 'contactUs', right: 'menu.sys.info.contactUs'},
          // { title: '消息通知', url: 'noticeList', right: 'menu.sys.info.noticeList' },
          // { title: '意见投诉', url: 'complaintList', right: 'menu.sys.suspect.alarmList' }
        ]
      },
      {
        title: '系统管理',
        icon: 'md-settings',
        url: 'security',
        children: [
          {title: '组织架构', url: 'branch', right: 'menu.sys.security.branch'},
          {title: '角色权限', url: 'role', right: 'menu.sys.security.role'},
          {title: '系统设置', url: 'sysSet', right: 'menu.sys.security.sysSet'},
          {title: '修改词典', url: 'dictionary', right: 'menu.sys.security.dictionary'}
        ]
      }],
    // 不放在菜单里面的页面
    pages: [
      {title: '用户信息', url: 'user/userCenter'},
      {title: '帮助中心', url: 'frame/help'},
      {title: '控件安装', url: 'help/controlProblem'}
    ]
  },

  filter(user, actOn) {
    return system.pages.menu.filter(item =>
      (
        user.menuArrayJson && user.menuArrayJson.indexOf('admin') > -1 ||
        (item.children = item.children.filter(node =>
          user.roles.some(role => role.rightsArrayJson.indexOf(node.right) > -1) ||
          user.rightsArrayJson && user.rightsArrayJson.indexOf(node.right) > -1 || node.menu === false)).length > 0
      ) && actOn.indexOf(item.url) > -1
    )
  }
}


export default system